import React, { useState } from 'react';
import FirstPage from './FirstPage';
import { TDirectorInfo } from '../../../types';
import AddDirector from './AddDirector';

type TProps = {
  isAnyShareholderDirector: string;
  setIsAnyShareholderDirector: React.Dispatch<React.SetStateAction<string>>;
  setDirectorsInShareholders: React.Dispatch<React.SetStateAction<number[]>>;
  directorsInShareholders: number[];
  shareholders: TDirectorInfo[];
  directors: TDirectorInfo[];
  setDirectors: React.Dispatch<React.SetStateAction<TDirectorInfo[]>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  current: number;
  setCurrent: React.Dispatch<React.SetStateAction<number>>;
};
const Director = ({
  directorsInShareholders,
  isAnyShareholderDirector,
  setDirectorsInShareholders,
  setIsAnyShareholderDirector,
  setDirectors,
  setStep,
  shareholders,
  directors,
  current,
  setCurrent,
}: TProps) => {
  return (
    <div>
      {current === -1 ? (
        <FirstPage
          isAnyShareholderDirector={isAnyShareholderDirector}
          setIsAnyShareholderDirector={setIsAnyShareholderDirector}
          setDirectorsInShareholders={setDirectorsInShareholders}
          directorsInShareholders={directorsInShareholders}
          shareholders={shareholders}
          setCurrent={setCurrent}
          directors={directors}
          setStep={setStep}
          current={current}
        />
      ) : (
        <AddDirector
          currentDirector={current}
          directors={directors}
          setCurrentDirector={setCurrent}
          setDirectors={setDirectors}
          setStep={setStep}
        />
      )}
    </div>
  );
};

export default Director;
